<template>
    <div class="register-container">
        <head-bar title="注册" :fixed="true">
            <template v-slot:right>
                <div
                    class="head-right-slot"
                    @click="gotoView('/account/login/password')"
                >
                    <span>登录</span>
                </div>
            </template>
        </head-bar>
        <div class="register-form">
            <div class="form-item margin-b">
                <div class="input-icon person-icon"></div>
                <input
                    type="text"
                    v-model="registerInfo.userPhone"
                    maxlength="11"
                    class="input-common"
                    placeholder="手机号码"
                />
            </div>
            <div class="form-item margin-b">
                <div class="input-icon code-icon"></div>
                <div class="code-box" @click="getPhoneCode">
                    <span>{{ codeText }}</span>
                </div>
                <input
                    type="text"
                    v-model="registerInfo.smsCode"
                    maxlength="6"
                    class="input-common"
                    placeholder="短信验证码"
                />
            </div>
        </div>
        <div class="register-btn" @click="gotoSetPassword">
            <span>下一步</span>
        </div>
        <div class="register-agreement" @click="$router.push('/serve/clause')">
            <span>注册代表您同意</span>
            <em>用户协议</em>
        </div>
    </div>
</template>
<script>
import HeadBar from "@/components/HeadBar.vue";
import { isPhone, isEmpty } from "@/utils/validation";
import Vue from "vue";
import utils from "@/utils/utils";
import { Toast } from "vant";
Vue.use(Toast);
const CODE_TEXT = "获取验证码";
//验证码类型
const CODE_TYPE_REGISTER = 0;
export default {
    name: "Register",
    components: {
        HeadBar,
    },
    mounted() {},
    data() {
        return {
            //注册信息
            registerInfo: {
                userPhone: "", //用户手机
                userPassword: "", //用户密码
                confirmPassword: "", //确认密码
                recommendCode: "", //推荐人
                smsCode: "", //手机验证码
            },
            isSendCode: false, //是否发送验证码中
            codeText: CODE_TEXT, //验证码文字
            isSumbitIng: false,
        };
    },
    methods: {
        /**
         * @description 跳转页面
         */
        gotoView(path) {
            if (!path) return;
            this.$router.push({
                path: path,
            });
        },
        /**
         * @param {{object}} registerInfo 注册信息
         * @description 检测注册数据
         */
        validateRegisterInfo(registerInfo) {
            let { userPhone, smsCode } = registerInfo;
            if (!isPhone(userPhone)) {
                this.$toast("请输入正确的手机号码");
                return false;
            } else if (isEmpty(smsCode)) {
                this.$toast("请输入验证码");
                return false;
            }
            return true;
        },
        /**
         * @description 获取手机验证码
         */
        getPhoneCode() {
            let { userPhone } = this.registerInfo;
            let _this = this;
            if (this.isSendCode) return;
            if (!isPhone(userPhone)) {
                this.$toast("请输入正确的手机号码");
                return;
            }
            _this.hasUser(userPhone, (hasUser) => {
                if (hasUser) {
                    _this.$toast("此号码已经注册");
                    return;
                }
                _this.$axios
                    .post(_this.$api.commonApi.sendVerificationCode, {
                        userAccount: userPhone,
                        sendMsgType: CODE_TYPE_REGISTER,
                    })
                    .then((response) => {
                        _this.isSendCode = true;
                        utils.countDown(60, (second) => {
                            _this.codeText = `${second}s`;
                            if (second <= 0) {
                                _this.isSendCode = false;
                                _this.codeText = CODE_TEXT;
                            }
                        });
                    })
                    .catch(() => {
                        _this.isSendCode = false;
                    });
            });
        },
        /**
         * @description 跳转设置密码
         */
        gotoSetPassword() {
            if (!this.validateRegisterInfo(this.registerInfo)) return;
            this.$router.push({
                path: "/account/set/password",
                query: {
                    phone: this.registerInfo.userPhone,
                    smsCode: this.registerInfo.smsCode,
                    recommend: this.registerInfo.recommendCode,
                },
            });
        },
        /**
         * @description 是否注册此用户
         */
        hasUser(phone, cb) {
            if (!phone) {
                cb && cb(false);
            }
            let _this = this;
            this.$axios
                .post(_this.$api.accountApi.hasUser, {
                    userPhone: phone,
                })
                .then((response) => {
                    let isRegister = response.data || false;
                    cb(isRegister);
                })
                .catch(() => {});
        },
    },
};
</script>
<style lang="less" scoped>
.head-right-slot {
    padding-right: 35px;
    font-size: 32px;
    text-align: right;
    color: #333;
}
.register-container {
    padding-top: 90px;
}
.register-form {
    margin: 60px auto 0;
    width: 550px;
    .form-item {
        position: relative;
        width: 550px;
        height: 90px;
        &.margin-b {
            margin-bottom: 15px;
        }
        .input-icon {
            position: absolute;
            z-index: 1;
            width: 48px;
            height: 48px;
            left: 0;
            top: 50%;
            margin-top: -24px;
            background-repeat: no-repeat;
            background-position: center;
            background-size: 48px;
            &.person-icon {
                background-image: url("../../public/images/account/person-icon.png");
            }
            &.code-icon {
                background-image: url("../../public/images/account/code-icon.png");
            }
            &.password-icon {
                background-image: url("../../public/images/account/password-icon.png");
            }
        }
        .input-common {
            display: block;
            padding-left: 70px;
            width: 480px;
            height: 90px;
            background-color: #fff;
            border-top: none;
            border-bottom: 1px solid #f2f2f2;
            border-left: none;
            border-right: none;
            font-size: 32px;
            line-height: 90px;
            color: #333;
            &:focus {
                border-bottom: 1px solid @theme-color;
            }
        }
        .code-box {
            position: absolute;
            z-index: 1;
            top: 0;
            right: 0;
            width: 160px;
            height: 90px;
            font-size: 28px;
            line-height: 90px;
            color: @theme-color;
            text-align: center;
        }
    }
}
.register-btn {
    margin: 60px auto 40px;
    width: 550px;
    height: 80px;
    border-radius: 50px;
    background-color: @theme-color;
    font-size: 34px;
    line-height: 80px;
    text-align: center;
    color: #fff;
}
.register-agreement {
    font-size: 28px;
    text-align: center;
    span {
        color: #999;
    }
    em {
        padding-left: 20px;
        color: #3281da;
    }
}
</style>
